import React, { Fragment, useContext } from 'react'; 
import { GlobalInfo } from '../../Contexts/GlobalContext';
import humburgur from '../../Assets/images/humburgur.svg';
const Greeting = ({ userName }) => {
  const { appUserIsLogin, theme, GetData, toggleSidebar } = useContext(GlobalInfo);  
  const getGreetingMessage = () => { 
    return( 
    <>
     <button onClick={toggleSidebar} className="btn " id="sidebar-open">
          <img src={humburgur} alt="" />
        </button>
        
    <div className="el-topbar-left">
      
      Welcome, <span>{userName}!</span></div>
    </>
    );
  }; 
  return (
    <Fragment>
      {getGreetingMessage()}
      {/* <button type="button" onClick={()=>{GetData(appUserIsLogin)}}>click</button> */}
    </Fragment>
  );
}; 
export default Greeting; 